import React from "react";
import { useTheme } from "@emotion/react";
import { AppTheme } from "myplan/utils/theme";
import chroma from "chroma-js";
import { useSafeAreaFrame } from "react-native-safe-area-context";
import {
	Container,
	ScoreContainer,
	Score,
	ScoreLabel,
	Pointer,
	Graph,
	Segment,
	SegmentBar,
	SegmentTitle,
	SegmentRange,
	CONTAINER_PADDING_HORIZONTAL,
} from "./styles";

const startColor = "#FFDB62";
const endColor = "#EF5C42";
const scale = chroma.scale([startColor, endColor]);

const LinearColorGraph = ({
	result,
	tally,
	levelMatchIndex,
	inline = false,
}) => {
	const {
		color: { text: pointerColor },
	}: AppTheme = useTheme() as AppTheme;
	tally = Math.max(0, tally);
	let { width } = useSafeAreaFrame();
	if (inline) width = width - 110; // subtract width of QuizQueue list item image
	// const scoreLabelWidth = 170;
	const segmentWidth =
		(width - CONTAINER_PADDING_HORIZONTAL * 2) / result.levels.length;
	let translateX = segmentWidth * levelMatchIndex;
	let scoreLabelAlignment = "center";

	if (result.displayCaratScore) {
		// adjust score label position based upon pointer position
		// if index is zero, left align
		if (levelMatchIndex === 0) scoreLabelAlignment = "flex-start";
		// if last index, right align and adjust margin to accommodate
		if (levelMatchIndex === result.levels.length - 1) {
			scoreLabelAlignment = "flex-end";
		}
	}

	const POINTER_HEIGHT = inline ? 12 : 22;

	return (
		<Container inline={inline}>
			<ScoreContainer inline={inline}>
				<Score
					translateX={translateX}
					align={scoreLabelAlignment}
					inline={inline}>
					{result.displayCaratScore && (
						<ScoreLabel allowFontScaling={false}>
							{result.caratScorePrefix || "Your score:"}
							{` `}
							{tally}
						</ScoreLabel>
					)}
					<Pointer
						tally={tally}
						height={POINTER_HEIGHT}
						color={pointerColor}
					/>
				</Score>
			</ScoreContainer>
			<Graph>
				{result.levels.map((level, levelIndex) => {
					const nextLevel = result.levels[levelIndex + 1];
					const position = levelIndex / (result.levels.length - 1);
					const color = scale(position).hex();
					let rangeLabel;
					let width = `${100 / result.levels.length}%`;

					if (
						result.displayGraphLabels &&
						level.tallyThreshold === -1 &&
						nextLevel.tallyThreshold === 1
					) {
						return null;
					}

					if (levelIndex === 0) {
						rangeLabel = `<${nextLevel.tallyThreshold}`;
					} else if (!nextLevel) {
						rangeLabel = `${level.tallyThreshold}+`;
					} else {
						rangeLabel = `${level.tallyThreshold}-${
							nextLevel.tallyThreshold - 1
						}`;
					}

					return (
						<Segment key={level._id} style={{ width }}>
							<SegmentBar style={{ backgroundColor: color }} />
							{result.displayGraphLabels && (
								<>
									<SegmentTitle
										allowFontScaling={false}
										inline={
											inline
										}>{`${level.graphLabel}`}</SegmentTitle>
									<SegmentRange
										inline={inline}
										allowFontScaling={false}>
										{rangeLabel}
									</SegmentRange>
								</>
							)}
						</Segment>
					);
				})}
			</Graph>
		</Container>
	);
};

export default LinearColorGraph;
